






import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class Error401UnauthorizedView extends Vue {
    private mounted() {
        this.$root.$emit('change-active-page', 'views.errors.error401UnauthorizedView.pageName');
    }
}
